<template>
  <a-popover placement="topRight" v-model:visible="popVisible" trigger="hover">
    <template #content>
      <div class="chatComs">
        <div
          v-for="(item, index) in actionlist"
          class="actionItem"
          :key="index"
          @click="actionClick(item)"
        >
          <auth-img :src="item.pic" class="actionImg" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </template>
    <a href="#">沟通{{ receiver === 'patient' ? '患者' : '医生' }}</a>
  </a-popover>
</template>

<script setup>
import { defineProps, ref, defineEmits, createVNode, computed } from 'vue'
import { useStore } from 'vuex'
import { callOut } from '@/utils/Tccc'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal } from 'ant-design-vue'

const props = defineProps({
  receiver: {
    type: String,
    default: 'patient'
  }
})

const popVisible = ref(false)
const publicImg = require('@/assets/img/work-place/public.png')
const privateImg = require('@/assets/img/work-place/private.png')
const callPhone = require('@/assets/img/work-place/callPhone.png')

const actionlist = ref([
  { pic: privateImg, title: '发起私聊', type: 'chatPrivate' },
  { pic: publicImg, title: '多方会话', type: 'chatPublic' },
  { pic: callPhone, title: '拨打电话', type: 'callPhone' }
])

const store = useStore()
const emit = defineEmits(['ChatTo'])
const actionClick = ctx => {
  popVisible.value = false
  if (ctx.type !== 'callPhone') {
    emit('ChatTo')
    store.commit('app/SET_TABS_ACTIVE', 'Chat')
    switch (ctx.type) {
      // 问诊会话
      case 'chatPublic':
        store.commit('app/SET_CHATRECEIVER_TYPE', { type: 'public' })
        break
      // 私聊患者或医生
      case 'chatPrivate':
        if (props.receiver === 'patient') {
          store.commit('app/SET_CHATRECEIVER_TYPE', { type: 'private', receiver: props.receiver })
        } else {
          store.commit('app/SET_CHATRECEIVER_TYPE', { type: 'private', receiver: props.receiver })
        }
        break
    }
  } else {
    call()
  }
}

const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const call = () => {
  const ctxInfo =
    props.receiver === 'patient' ? curOrder.value.patientInfo : curOrder.value.doctorInfo
  const ctxUser = props.receiver === 'patient' ? '患者' : '医生'
  Modal.confirm({
    centered: true,
    title: '确定拨打电话',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定给${ctxUser}-${ctxInfo.username}拨打电话吗？`,
    okText: '拨打',
    cancelText: '取消',
    onOk: () => {
      const params = {
        calleeType: Number(props.receiver === 'patient') + 1,
        calleeUcUserId: ctxInfo.ucUserId,
        doctorId: ctxInfo.businessId,
        workOrderIds: []
      }
      callOut(params, {
        userType: ctxUser,
        name: ctxInfo.username
      })
    }
  })
}
</script>
<style lang="scss" scoped>
.chatComs {
  display: flex;
  justify-content: space-between;
  width: 212px;
  border-radius: 20px;
  .actionItem {
    text-align: center;
    cursor: pointer;
  }
  .actionImg {
    width: 24px;
    height: 24px;
    margin-bottom: 4px;
  }
}
</style>
